import { defineComponent as o, openBlock as a, createBlock as n, unref as r, withCtx as i, createElementVNode as p } from "vue";
import f from "../SfIconBase/SfIconBase.vue.mjs";
import { SfIconSize as m } from "@storefront-ui/shared";
const u = /* @__PURE__ */ o({
  __name: "SfIconExpandMore",
  props: {
    size: {
      type: String,
      default: m.base
    }
  },
  setup(t) {
    return (s, e) => (a(), n(r(f), {
      size: t.size,
      viewBox: "0 0 24 24",
      "data-testid": "expand-more"
    }, {
      default: i(() => e[0] || (e[0] = [
        p("path", { d: "M17 9.003a1 1 0 0 0-1.41 0l-3.885 3.876L7.82 9.003a.998.998 0 0 0-1.41 1.411l4.588 4.588a1 1 0 0 0 1.414 0L17 10.414a.997.997 0 0 0 0-1.41" }, null, -1)
      ])),
      _: 1
    }, 8, ["size"]));
  }
});
export {
  u as default
};
